<div
  class="bg-primary-on box-border flex w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div
    class="bg-input-accessibility border-input-accessibility border-input text-input-accessibility-text rounded-l-input peer p-input flex w-16 items-center placeholder-transparent">
    <span class="material-symbols-rounded absolute"> accessibility_new </span>
  </div>
  <div class="rounded-input relative w-full rounded-l-none! bg-inherit">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      [formControl]="ngControl.control! | toFormControl"
      [ngClass]="{
        'pointer-events-none': ngControl.disabled,
      }"
      [id]="id()"
      [placeholder]="label() ?? ''"
      class="border-input-ring border-input rounded-r-input peer p-input w-full bg-transparent placeholder-transparent focus:border-input-focus focus:ring-0"
      type="text" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-label peer-focus:text-input-focus pointer-events-none absolute -top-2 left-4 cursor-text bg-inherit text-sm transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [ngClass]="{
        'border-input-error peer-focus:border-input-focus': hasError,
        'border-input-ring peer-focus:border-input-focus': !hasError,
        'text-input-error': hasError,
      }"
      [for]="id()">
      {{ formattedLabel() }}
    </label>
  </div>
</div>
@if (hasError && !errorTemplate()) {
  <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
    <ng-content></ng-content>
  </aw-error-message>
}
@if (hasError && errorTemplate()) {
  <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
    <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
  </aw-error-message>
}
